module.exports = "<div class=_wrapper ui-view=bars-main></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bars/states/bars/main.html
// module id = 489
// module chunks = 0